var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "event-item",
      class: { noTransition: _vm.isNoTrans, "clear-both": _vm.isClear }
    },
    [
      _vm.isEM
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.hover.bottom",
                  modifiers: { hover: true, bottom: true }
                }
              ],
              staticClass: "event-item-custom-message",
              attrs: { title: "More details" },
              on: {
                click: function($event) {
                  _vm.openModal()
                }
              }
            },
            [
              _c("div", {
                staticClass: "event-item-custom-message-icon icon-gear"
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isAdminRole()
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.hover.bottom",
                  modifiers: { hover: true, bottom: true }
                }
              ],
              staticClass: "delete-client-button",
              attrs: { title: "Delete" },
              on: {
                click: function($event) {
                  _vm.deleteClientClick()
                }
              }
            },
            [_c("div", { staticClass: "icon-delete" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "event-item-header" }, [
        _c("div", { staticClass: "wrapper-event-item-name" }, [
          _c(
            "div",
            {
              staticClass: "event-item-name",
              on: {
                click: function($event) {
                  _vm.gotoUserView()
                }
              }
            },
            [_c("span", [_vm._v(_vm._s(_vm.client.clientName))])]
          )
        ]),
        _vm._v(" "),
        !_vm.isClientManager()
          ? _c("div", { staticClass: "event-item-role" }, [
              _c(
                "div",
                { staticClass: "event-manager" },
                [
                  _c(
                    "b-form-group",
                    { staticClass: "ap-dropdown", attrs: { vertical: "" } },
                    [
                      _c(
                        "b-dropdown",
                        {
                          directives: [
                            {
                              name: "modal",
                              rawName: "v-modal",
                              value: _vm.client.eventManagerId,
                              expression: "client.eventManagerId"
                            }
                          ],
                          staticClass: "ap-dropdown-btn",
                          attrs: {
                            "no-caret": "",
                            disabled: !(
                              _vm.isEventManager() || _vm.isAdminRole()
                            )
                          }
                        },
                        [
                          _c("template", { slot: "button-content" }, [
                            _c("div", { staticClass: "button-content" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "text",
                                  class: { active: _vm.emName != "" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.client.eventManagerName || "Choose EM"
                                    )
                                  )
                                ]
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "ap-dropdown-menu" },
                            _vm._l(_vm.listEM, function(item) {
                              return _c(
                                "b-dropdown-item",
                                {
                                  key: item,
                                  staticClass: "ap-dropdown-item",
                                  attrs: { value: item.id },
                                  on: {
                                    click: function($event) {
                                      _vm.dropdownItemClick(item)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "ap-item-wrapper" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "ap-item-content" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              item.firstName +
                                                " " +
                                                item.lastName
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            })
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "event-item-role-text-am custom-multiselect" },
                [
                  _c("multiselect", {
                    staticClass: "multiple-select-am",
                    attrs: {
                      options: _vm.listAM,
                      label: "name",
                      placeholder: "Choose AM",
                      "show-no-results": false,
                      "allow-empty": false,
                      "show-labels": false,
                      "max-height": 100,
                      disabled: !(_vm.isEventManager() || _vm.isAdminRole())
                    },
                    on: { input: _vm.selectAm },
                    model: {
                      value: _vm.selectedAm,
                      callback: function($$v) {
                        _vm.selectedAm = $$v
                      },
                      expression: "selectedAm"
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("ClientCardFooter", { attrs: { client: _vm.client } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-020621ec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-020621ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commons/ClientCard.vue
// module id = 1588
// module chunks = 1